import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { CurrencyPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { RiderCartItem } from '../../shopping-cart.types';

@Component({
  selector: 'cipx-rider-cart-item',
  template: `
    <div class="w-full">
      <mat-expansion-panel>
        <mat-expansion-panel-header class="h-20">
          <div class="flex flex-row justify-between items-center w-full">
            <div class="flex flex-col">
              <span class="font-bold text-lg">
                {{ item.display_name }}
              </span>
              <p class="text-sm text-gray-500 mt-1">
                Rider Item
              </p>
            </div>
            <div class="flex flex-col items-end">
              <span class="font-bold text-lg text-green-600">
                {{ item.getTotal() | currency: 'USD' }}
              </span>
              <button
                mat-icon-button
                (click)="removeItem.emit(item); $event.stopPropagation()">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </mat-expansion-panel-header>

        <div class="rounded-lg px-2">
          <div class="w-full flex flex-col justify-between pt-4">
            <p>Rider-specific content would go here...</p>

            <!-- Pricing Details -->
            <div class="mt-4 pt-4 border-t border-gray-200">
              <div class="flex justify-between font-bold text-lg">
                <span>Total:</span>
                <span class="text-green-600">{{ item.getTotalWithTaxAndShipping() | currency: 'USD' }}</span>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  `,
  imports: [
    MatExpansionPanelHeader,
    MatExpansionPanel,
    CurrencyPipe,
    MatIcon,
    MatIconButton,
  ],
  standalone: true,
})
export class CIPXRiderCartItemComponent {
  @Input() item!: RiderCartItem;
  @Output() removeItem = new EventEmitter<RiderCartItem>();
  @Output() updateQuantity = new EventEmitter<{ item: RiderCartItem, quantity: number }>();
  @Output() viewDetails = new EventEmitter<RiderCartItem>();
}
